import { FlushGraphQLCache, Navigate } from "event-definitions"

//AD: check
function extractProjectIdFromRoute(route) {
    const match = /^\/authoring\/projects\/([^/]+)$/.exec(route)
    return match ? match[1] : null
}

Navigate.before.handleOnce((route) => {
    if (!route) return
    const projectId = extractProjectIdFromRoute(route)
    if (projectId) {
        console.log("Entering project boundary! projectId:", projectId)
        FlushGraphQLCache.raise() //make project boundary event and follow noChange pattern
    }
})
